module.exports = __webpack_public_path__ + "img/product_97.08a7039.webp";